import { analytics } from "plugins";

export const sendSegment = (eventName: string, data: any) => {
  analytics.analyticsMethod("track", eventName, data);
};
